/**
 * Created by mohameds on 4/7/19.
 */
import React from 'react';
import Card from './common/Card';

const AgencyNumber = ({pageData = {}}) => (
    <React.Fragment>
        <div className="container-fluid my-1">
            <div className="row">
                <div className="col-md-12 text-center">
                    <p className="display-6 font-weight-bold">
                        {pageData && pageData.title && pageData.title}
                    </p>
                    <span className="hor-bar"/>
                </div>
            </div>
            <div className="row">
                {pageData.kpi_list && pageData.kpi_list.map((kpiData, index) => (
                    <Card key={index}
                          showGoal={pageData.goal}
                          text={kpiData.name}
                          goal={kpiData.goal}
                          actual={kpiData.actual}
                          dataType={kpiData.data_type}
                          index={index}
                    />
                ))}
            </div>
        </div>
    </React.Fragment>
)
export default AgencyNumber


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/AgencyNumber.js